import cableService from '@/widget/services/cableService';
import { Conversation } from '@/widget/domain/conversation';
import { DataStore } from '@/widget/services/useChatWidgetStore';

const requestData = ({ subscription, conversationKeys }: {
  subscription: ActionCable.Channel,
  conversationKeys: string[],
}) => (
  subscription.send({
    action_name: 'find_conversations_by_keys',
    payload: { keys: conversationKeys },
  })
);

function handleConversationsFound({ data, store }: { data: Conversation[], store }) {
  const { setConversations }: DataStore = store.getState();
  setConversations(data, true);

  data.forEach((conversation) => {
    window.ChatWidget.cable.subscriptions.create(
      { channel: 'ChatWidgetChannel', key: conversation.key },
      {
        received: (payload) => cableService(payload, store),
      },
    );
  });
}

const ConversationsDispatcher = {
  requestData,
  handleConversationsFound,
};

export default ConversationsDispatcher;
